import * as types from '../store/types';

import select from '../store/selectors';

export function setPayment(data) {
  return (dispatch, getState) => {
    dispatch({
      type: types.INIT_PAYMENT,
      payload: data,
    });

    const selector = select(getState());

    return selector.getPayment();
  };
}

export function setPaymentIfNeeded(data) {
  return (dispatch, getState) => {
    const state = getState();

    let selector = select(state);

    const payment = selector.getPayment();

    if (data.hasOwnProperty('sign')) {
      return dispatch(setPayment(data));
    } else {
      return payment;
    }
  };
}

export function setPaymentPayWay(id) {
  return {
    type: types.SET_PAYMENT_PAY_WAY,
    payload: id,
  };
}
